module.exports = __webpack_public_path__ + "img/smartchurch-logo.07b393f2.png";